export default function (elements, offset) {
    if (typeof offset === 'undefined') {
        offset = 0;
    }
    const run = () => {
        const $elements = jQuery(elements).not('[data-vertical-center=false]');

        $elements.each((index, item) => {
            const height = jQuery(item).parent().height();
            const itemHeight = jQuery(item).outerHeight();

            if (height > itemHeight) {
                const itemAddOn = (height - itemHeight) / 2;
                jQuery(item).css('top', Math.floor(itemAddOn) + offset);
            } else {
                jQuery(item).css('top', '0px');
            }
            jQuery(item).css('position', 'relative');
            jQuery(item).addClass('visible');
        });
    };

    jQuery(elements).imagesLoaded(() => {
        jQuery(window).on('resize', () => {
            run();
        });
        run();
    });
}



// WEBPACK FOOTER //
// ./scripts/util/verticalCenter.js